exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step-finished .box[data-v-715c900d] {\n  padding: 20px;\n}\n.step-finished .action-buttons[data-v-715c900d] {\n  display: flex;\n  gap: 12px;\n  justify-content: stretch;\n}\n.step-finished .action-buttons button[data-v-715c900d] {\n  flex: 1;\n  justify-content: center;\n}\n", ""]);

// exports
